const shared={
    check:'Customers',
    title:'Frontend User',
    url:'customer',
    addApi:'api/event/create',
    editApi:'api/event/edit',
    detailApi:'api/event/details',
    listApi:'api/event/all',
    statusApi:'api/event/edit',
    deleteApi:'api/event/delete'
}

export default shared